export const API_PATH_SYNC_CHECK: string = "/checks";
export const API_PATH_SYNC_CHECK_POST: string = "/cron/caclendar/check";
export enum SYNC_CHECK_CONSTANT {
    RESULT_NG = "ng",
    RESULT_OK = "ok",
    RESULT_ERROR = "error",
}
